import styled, { css } from 'styled-components';

import { SPACING } from '~/common/constants/spacing';
import { hexToRgba } from '~/common/utils/hex-to-rgba';

export const SelectionBadgeContainer = styled.button<{
  $selected: boolean;
  $variant?: 'default' | 'subcategory';
}>`
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  padding: ${SPACING._6} ${SPACING._12};
  border-radius: 12px;
  transition: 200ms;
  border: 1px solid
    ${({ theme, $selected, $variant }) => {
      if ($selected) return theme.primary;
      if ($variant === 'subcategory') return hexToRgba(theme.primary, 0.35);
      return theme.neutral800;
    }};
  background-color: ${({ theme, $selected, $variant }) => {
    if ($selected) return theme.primary;
    if ($variant === 'subcategory') return hexToRgba(theme.primary, 0.18);
    return theme.neutral950;
  }};

  ${({ $selected, theme, $variant }) =>
    $selected
      ? css`
          &:hover {
            filter: brightness(1.1);
          }
        `
      : css`
          &:hover {
            background-color: ${$variant === 'subcategory'
              ? hexToRgba(theme.primary, 0.28)
              : theme.neutral900};
            border-color: ${$variant === 'subcategory'
              ? hexToRgba(theme.primary, 0.5)
              : theme.neutral700};
          }
        `}
`;
